(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetView', {
		bindings: {
			parameters: '=',
			view: '=',
			preprocessors: '=?',
		},
		controller: MxContentWidgetViewCtrl,
		controllerAs: 'vm',
	});

	MxContentWidgetViewCtrl.$inject = [
		'mx.SolutionBuilderAgent.ContentWidgetService',
		'mx.shell.ContextService',
		'$scope',
		'$element',
		'$compile',
		'$rootScope',
		'mx.shell.Config',
		'$q',
	];

	function MxContentWidgetViewCtrl(contentWidgetService, contextService, $scope, $element, $compile, $rootScope, mxConfig, $q) {
		var vm = this,
			localScope;

		vm.$onInit = function () {
			contentWidgetService.widgetSync(contextService.val('SolutionBuilderAgent.ContentWidgetId'));
		};

		$scope.$watch('vm.view', function (viewType) {
			if (viewType !== '' && viewType !== undefined && viewType !== null) {
				init(viewType, vm.parameters);
			}
		});

		return vm;

		function init(view) {
			var directive;
			var templatePromise, viewType;

			if (view === null) {
				return;
			}

			// To do: rework code below
			if (typeof view === 'number') {
				templatePromise = $q.when('');
				viewType = view;
			} else if (typeof view === 'string') {
				templatePromise = $q.when(view);
				viewType = mx.SolutionBuilderAgent.ContentWidgetViewType.DialogPage;
			} else {
				if (view === undefined) {
					return;
				}
				templatePromise = $q.when(view.Template || '');
				viewType = view.Type;
			}

			switch (viewType) {
				case mx.SolutionBuilderAgent.ContentWidgetViewType.List:
					directive = 'mx-content-widget-view-list';
					break;
				case mx.SolutionBuilderAgent.ContentWidgetViewType.Tile:
					directive = 'mx-content-widget-view-tiles';
					break;
				case mx.SolutionBuilderAgent.ContentWidgetViewType.Grid:
					directive = 'mx-content-widget-view-grid';
					break;
				case mx.SolutionBuilderAgent.ContentWidgetViewType.ObjectDetails:
				case mx.SolutionBuilderAgent.ContentWidgetViewType.DialogPage:
					directive = 'mx-content-widget-view-dialog-page';
					break;
				case mx.SolutionBuilderAgent.ContentWidgetViewType.NonVisual:
					directive = 'mx-content-widget-view-non-visual';
					break;
				case mx.SolutionBuilderAgent.ContentWidgetViewType.Calendar:
					directive = 'mx-content-widget-view-calendar';
					break;
				case mx.SolutionBuilderAgent.ContentWidgetViewType.Board:
					directive = 'mx-content-widget-view-board';
					break;
				default:
					directive = 'mx-content-widget-view-grid';
			}

			templatePromise.then(function (template) {
				var str = template.indexOf('layout_container_mode_panel') === -1 ? '' : 'class="dialog-panel-container"'; // Thx Medgit

				if (
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.List ||
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.Tile ||
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.Board
				) {
					var re = new RegExp('vm.dataModel.DataQuery.return', 'g');
					template = template.replace(re, 'item');
				}

				if (
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.List ||
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.Tile ||
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.Grid ||
					viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.Board
				) {
					str += ' output-preprocessors="vm.preprocessors" ';
				}

				if (viewType === mx.SolutionBuilderAgent.ContentWidgetViewType.Board) {
					vm.parameters.board = vm.parameters.board || {};
					vm.parameters.board.template = template;
				}

				if (directive === 'mx-content-widget-view-tiles') {
					var found = template.match(/mx-tile="(.+?)"/i);

					str += ' data-tiles-config="' + (found.length === 2 ? found[1] : '') + '" ';

					// To do: this is temp (quick) workaround fix for mobile tile view.
					// This code removes "mobile classes" like "layout-xs-column" "layout-sm-column" from tile view.
					// Server-side transformation (html-generator) should not generate those classes for Tiles at all (or do it optionally) because it breaks it.
					// But maybe(maybe not) those mobile classes are needed for something else (like dialogs or forms or lists).
					// That's why it's very risky to remove those classes for all on server-side transformation before Release.
					[
						'layout-xs-column',
						'layout-sm-column',
						'layout-xs-row',
						'layout-sm-row',
						'layout-align-xs-start-stretch',
						'layout-align-sm-start-stretch',
						'layout-align-xs-end-stretch',
						'layout-align-sm-end-stretch',
					].forEach(function (cls) {
						template = template.split(cls).join('');
					});
				}

				compile(
					(vm.parameters.nonVisualTemplate
						? '<mx-content-widget-view-non-visual data-parameters="vm.parameters.dataModel">' + vm.parameters.nonVisualTemplate + '</mx-content-widget-view-non-visual>'
						: '') +
						'<' +
						directive +
						' data-parameters="vm.parameters" ' +
						' class="layout-column flex" ' +
						str +
						'>' +
						template +
						'</' +
						directive +
						'>'
				);
			});
		}

		function compile(tpl) {
			destroy();
			localScope = $rootScope.$new(false, $scope);

			// TO DO: do not set config that way: dataModel.config .
			// Use dataModel.Context.__config instead. And why vm.parameters.dataModel could be empty ?
			if (vm.parameters.hasOwnProperty('dataModel')) {
				vm.parameters.dataModel.config = mxConfig;
			} else {
				vm.parameters.config = mxConfig;
			}
			vm.preprocessors = {};
			localScope.vm = { parameters: vm.parameters, preprocessors: vm.preprocessors };

			var _elem = angular.element(tpl);
			$element.append(_elem);
			$compile(_elem)(localScope);
			$element.on('$destroy', destroy);
		}

		function destroy() {
			if (localScope) {
				localScope.$destroy();
				$element.empty();
				localScope = null;
			}
		}
	}
})();
